import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Logo from '../../components/Svg/ActionButtonLogo';
import { setOverlayVisible } from './actions.js';
import OverlayGeneric from '../../components/Overlay/OverlayGeneric';
import ActionButtonDescription from '../../components/Overlay/ActionButtonDescription';

const Overlay = props => (
    <OverlayGeneric
        logoComponent={Logo}
        aboutUsComponent={ActionButtonDescription}
        aboutUsContent={{}}
        isVisible={props.isVisible}
        isMobileResolution={props.isMobileResolution}
        setOverlayVisible={props.setOverlayVisible}
        transitionType={'left-to-right'}
        title=""
        subscribeForm={true}
    />
);

Overlay.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    isMobileResolution: PropTypes.bool.isRequired,
    setOverlayVisible: PropTypes.func.isRequired
};

export default connect(
    state => {
        return {
            isVisible: state.widget.isOverlayVisible,
            isMobileResolution: state.widget.isMobileResolution
        };
    },
    { setOverlayVisible }
)(Overlay);



// WEBPACK FOOTER //
// ./src/containers/Widget/Overlay.jsx